import OpinionText from "./component";

export default OpinionText;